// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import Select from 'Common/Select';
import Input from 'Common/Input';
import Checkbox from 'Common/Checkbox';

// Helpers
import classNames from 'classnames';

/**
 * <AdvancedFilters /> component.
 */
class AdvancedFilters extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   * @prop {object} bootstrap - bootstrap.
   * @prop {object} fields - fields.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    bootstrap: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
    additonalOptions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    resultsLength: PropTypes.number
  };

  /**
   * Renders <AdvancedFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render() {
    const { styles, bootstrap, fields, isLoading, resultsLength } = this.props;
    const {
      fuelTypes,
      transmissions,
      colours,
      doors,
      seats,
      mileages,
      annualTax,
      fuelConsumption,
      co2Emissions,
      acceleration,
      insuranceGroup,
      yearFrom,
      yearTo,
      engineSizeFrom,
      engineSizeTo
    } = this.props.additonalOptions;

    return (
      <div className={styles.formRow}>
        <div className={classNames(styles.formRowItem)}>
          <div
            className={classNames(
              styles.doubleSelect,
              styles.doubleSelectNoPadding
            )}
          >
            <Checkbox
              name={'used'}
              label={'Used'}
              selectedValue={fields.used}
              isLanding={true}
              isDisabled={isLoading}
            />

            <Checkbox
              name={'nearlynew'}
              label={'Nearly new'}
              selectedValue={fields.nearlynew}
              isLanding={true}
              isDisabled={isLoading}
            />
          </div>

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'fuelType'}
            label={'Fuel type'}
            options={fuelTypes}
            selectedValue={fields.fuelType}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'gearBox'}
            label={'Gearbox'}
            options={transmissions}
            selectedValue={fields.gearBox}
            isDisabled={isLoading}
          />

          <Input
            styles={styles}
            bootstrap={bootstrap}
            name={'keyword'}
            label={'Keyword search'}
            selectedValue={fields.keyword}
            placeholderText={'Keyword search'}
            isValid={!!resultsLength}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'annualTax'}
            label={'Annual tax'}
            options={annualTax}
            selectedValue={fields.annualTax}
            isDisabled={isLoading}
          />

          <div className={classNames(styles.doubleSelect)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'yearFrom'}
              label={'Year from'}
              options={yearFrom}
              selectedValue={fields.yearFrom}
              isDisabled={isLoading}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'yearTo'}
              label={'Year to'}
              options={yearTo}
              selectedValue={fields.yearTo}
              isDisabled={isLoading}
            />
          </div>

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'mileage'}
            label={'Mileage'}
            options={mileages}
            selectedValue={fields.mileage}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'fuelConsumption'}
            label={'Fuel consumption'}
            options={fuelConsumption}
            selectedValue={fields.fuelConsumption}
            isDisabled={isLoading}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'co2Emissions'}
            label={'CO2 Emissions'}
            options={co2Emissions}
            selectedValue={fields.co2Emissions}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'insuranceGroup'}
            label={'Insurance group'}
            options={insuranceGroup}
            selectedValue={fields.insuranceGroup}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'colour'}
            label={'Colour'}
            options={colours}
            selectedValue={fields.colour}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'doors'}
            label={'Doors'}
            options={doors}
            selectedValue={fields.doors}
            isDisabled={isLoading}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'seats'}
            label={'Seats'}
            options={seats}
            selectedValue={fields.seats}
            isDisabled={isLoading}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'acceleration'}
            label={'Acceleration'}
            options={acceleration}
            selectedValue={fields.acceleration}
            isDisabled={isLoading}
          />

          <div className={classNames(styles.doubleSelect)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'engineSizeFrom'}
              label={'Engine size from'}
              options={engineSizeFrom}
              selectedValue={fields.engineSizeFrom}
              isDisabled={isLoading}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'engineSizeTo'}
              label={'Engine size to'}
              options={engineSizeTo}
              selectedValue={fields.engineSizeTo}
              isDisabled={isLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AdvancedFilters;



// WEBPACK FOOTER //
// ./src/Home/AdvancedFilters/index.js